// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"186f9a8b","244":"b10c4ec9","348":"02f7956e","422":"c28f59ea","453":"4e1314fb","663":"92dbcd87","951":"0ea3dafd"}[chunkId] + ".chunk.js";
};